'use client'

// Itens Consultoria e Livro do menu (SDD 2026-09-23, secao 9). O AppHeader e
// renderizado em mais de oito telas, cada uma com suas props; em vez de passar
// uma prop nova em todas, o menu pergunta a /api/acesso/menu uma vez por
// carregamento de pagina. Enquanto a resposta nao chega, os itens ficam
// escondidos: o padrao seguro e nao aparecer.

import { useEffect, useState } from 'react'

export interface MenuAcessoPago {
  consultoria: boolean
  livro: boolean
}

const NADA: MenuAcessoPago = { consultoria: false, livro: false }

let pedido: Promise<MenuAcessoPago> | null = null

function buscarMenu(): Promise<MenuAcessoPago> {
  if (!pedido) {
    pedido = fetch('/api/acesso/menu', { cache: 'no-store' })
      .then((r) => (r.ok ? (r.json() as Promise<MenuAcessoPago>) : NADA))
      .then((m) => ({ consultoria: m?.consultoria === true, livro: m?.livro === true }))
      .catch(() => NADA)
  }
  return pedido
}

export function useMenuAcessoPago(): MenuAcessoPago {
  const [menu, setMenu] = useState<MenuAcessoPago>(NADA)
  useEffect(() => {
    let vivo = true
    buscarMenu().then((m) => {
      if (vivo) setMenu(m)
    })
    return () => {
      vivo = false
    }
  }, [])
  return menu
}
